import type { HTMLProps, MouseEvent, ReactElement, ReactNode } from "react";
import { cloneElement, forwardRef } from "react";

import { useDrawer } from "@ui/components/Drawer/providers";

interface DrawerCloseTriggerProps extends HTMLProps<"button"> {
  children: ReactElement;
}

type ComponentProps = { onClick?: (event: MouseEvent) => void; children?: ReactNode; [key: string]: unknown };

export const DrawerCloseTrigger = forwardRef<HTMLButtonElement, DrawerCloseTriggerProps>((props, ref) => {
  const { closeDrawer } = useDrawer();

  const Component: ReactElement<ComponentProps> = Array.isArray(props.children) ? props.children[0] : props.children;
  const componentProps = Component.props;

  const mergedOnClick = (event: MouseEvent) => {
    componentProps?.onClick?.(event);
    closeDrawer();
  };

  return cloneElement(Component, { ...componentProps, onClick: mergedOnClick, ref }, componentProps.children);
});

DrawerCloseTrigger.displayName = "DrawerCloseTrigger";
